import { MsalAuthenticationResult } from '@azure/msal-react';

export const ErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => {
  return <div className='bg-red-500 text-white-bb font-bold text-base rounded-[4px] px-8 py-4'>An Error Occurred: {error ? error.errorCode : 'unknown error'}</div>;
};
